import { UserProfile } from '@/types/users'
import { computed } from '@vue/composition-api'

const useProfileIcons = (profile: UserProfile) => {
  // @ts-ignore
  const platform: Optional<string> = profile.agent?.platform
  // @ts-ignore
  const agentHeader: Optional<string> = profile.agent?.agent_header
  const appleMobile = new Set(['iPhone', 'iOS'])

  const deviceIcon = computed(() => {
    if (appleMobile.has(platform)) return 'mobile-alt'
    if (platform === undefined) return 'mobile-alt'
    if (platform.includes('arm')) return 'mobile-alt'
    if (agentHeader.toLowerCase().includes('android')) return 'mobile-alt'
    return 'laptop'
  })
  const osIcon = computed(() => {
    if (appleMobile.has(platform)) return 'brands/apple'
    if (platform === undefined) return 'brands/apple'
    if (agentHeader.toLowerCase().includes('android')) return 'brands/android'
    if (platform.toLowerCase().includes('arm')) return 'brands/android'
    if (platform.toLowerCase().includes('inux')) return 'brands/linux'
    if (platform.toLowerCase().includes('win')) return 'brands/windows'
    if (platform.toLowerCase().includes('mac')) return 'brands/apple'
    return 'brands/windows'
  })
  const platformIcon = computed(() => {
    if (platform === undefined || agentHeader === undefined) return 'brands/app-store'
    else return 'globe'
  })

  return {
    deviceIcon,
    osIcon,
    platformIcon
  }
}

export default useProfileIcons
